import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = ['Home', 'Eat', 'Drink', 'Nightlife', 'Gallery'];
  const getPath = (link: string) => link === 'Home' ? '/' : `/${link.toLowerCase()}`;
  const isActive = (link: string) => location.pathname === getPath(link);
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 px-6 md:px-8 py-4 md:py-6 ${isScrolled || isMobileMenuOpen ? 'bg-obsidian/95 backdrop-blur-md border-b border-champagne/10' : 'bg-transparent'}`} data-id="element-124">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-125">
        <Link to="/" className="z-50 flex items-center" data-id="element-126">
          <img src="https://cdn.magicpatterns.com/uploads/wi9wgmYeXMSb76H9MNpVfP/Red_Lounge_Logo.png" alt="Red Lounge Logo" className="h-10 w-10 md:h-12 md:w-12 rounded-lg object-cover shadow-lg border border-white/10" data-id="element-127" />
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex space-x-12" data-id="element-128">
          {navLinks.map(link => {
          const active = isActive(link);
          return <Link key={link} to={getPath(link)} className={`text-sm uppercase tracking-[0.3em] font-serif transition-colors duration-300 relative ${active ? 'text-champagne' : 'text-white/80 hover:text-champagne'}`} data-id="element-129">
                {link}
                {active && <motion.div layoutId="activeNavIndicator" className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-1 h-1 bg-champagne rounded-full" transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} data-id="element-130" />}
              </Link>;
        })}
        </div>

        {/* Desktop CTA */}
        <div className="hidden md:block relative group" data-id="element-131">
          <button className="text-sm uppercase tracking-[0.3em] font-serif bg-crimson text-white px-6 py-2 hover:bg-white hover:text-crimson transition-all duration-500 shadow-[0_0_15px_rgba(219,32,39,0.4)] flex items-center gap-2" data-id="element-132">
            Booking <ChevronDown size={14} data-id="element-133" />
          </button>
          <div className="absolute top-full right-0 mt-4 w-48 bg-obsidian/95 backdrop-blur-md border border-white/10 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 flex flex-col shadow-2xl" data-id="element-134">
            <a href="#" className="px-4 py-4 text-xs uppercase tracking-widest text-white/80 hover:text-champagne hover:bg-white/5 border-b border-white/5 transition-colors" data-id="element-135">
              Book a Table
            </a>
            <a href="#" className="px-4 py-4 text-xs uppercase tracking-widest text-white/80 hover:text-champagne hover:bg-white/5 border-b border-white/5 transition-colors" data-id="element-136">
              Order Food
            </a>
            <a href="#" className="px-4 py-4 text-xs uppercase tracking-widest text-white/80 hover:text-champagne hover:bg-white/5 transition-colors" data-id="element-137">
              Catering
            </a>
          </div>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-champagne z-50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-138">
          {isMobileMenuOpen ? <X size={24} data-id="element-139" /> : <Menu size={24} data-id="element-140" />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-141">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: '100vh'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="fixed inset-0 bg-obsidian z-40 flex flex-col items-center justify-center space-y-8 md:hidden" data-id="element-142">
            {navLinks.map(link => {
          const active = isActive(link);
          return <Link key={link} to={getPath(link)} onClick={() => setIsMobileMenuOpen(false)} className={`text-2xl uppercase tracking-[0.4em] font-serif transition-colors relative ${active ? 'text-champagne' : 'text-white hover:text-champagne'}`} data-id="element-143">
                  {link}
                  {active && <motion.div layoutId="activeNavIndicatorMobile" className="absolute -bottom-3 left-1/2 -translate-x-1/2 w-1.5 h-1.5 bg-champagne rounded-full" data-id="element-144" />}
                </Link>;
        })}

            <div className="flex flex-col items-center space-y-4 w-full max-w-xs mt-8 pt-8 border-t border-white/10" data-id="element-145">
              <span className="text-[10px] text-champagne uppercase tracking-[0.4em] mb-2" data-id="element-146">
                Booking
              </span>
              <button className="w-full text-xs uppercase tracking-[0.3em] font-serif bg-crimson text-white py-4 shadow-[0_0_15px_rgba(219,32,39,0.4)]" data-id="element-147">
                Book a Table
              </button>
              <button className="w-full text-xs uppercase tracking-[0.3em] font-serif border border-crimson text-crimson py-4 hover:bg-crimson hover:text-white transition-colors" data-id="element-148">
                Order Food
              </button>
              <button className="w-full text-xs uppercase tracking-[0.3em] font-serif border border-crimson text-crimson py-4 hover:bg-crimson hover:text-white transition-colors" data-id="element-149">
                Catering
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
}